
























































































import Vue from "vue";
import TheLayoutDrawerList from "./TheLayoutDrawerList.vue";
import Component from "vue-class-component";
import { constantRoutes } from "../../router";

@Component({
  components: { TheLayoutDrawerList },
})
export default class TheLayoutDrawer extends Vue {
  get permissionRoutes() {
    return constantRoutes;
  }
  get navbarShow() {
    return this.$store.getters.navbarShow;
  }
}
